import { ActionTree, Commit } from 'vuex';
import { IState } from './state';
import config from '@/params/config';
import * as TYPES from './types';
import { apiFetchAction, apiFetchData } from '../apiUtil';

// const apiRoot: string = `${config.neo}/${config.apiVersion}`;
const apiRoot: string = config.neo;

interface IActionContent {
  state: IState;
  commit: Commit;
}

// 获取反馈分页数据信息
const getFeedbackList = async (content: IActionContent, payload: object) => {
  await apiFetchAction(
    content.commit,
    'feedback/GetFeedbackPaging',
    'POST',
    TYPES.GET_FEEDBACK_LIST,
    payload,
    false,
    apiRoot
  );
};

// 获取反馈详情
const getFeedbackDetailById = async (
  content: IActionContent,
  payload: object
) => {
  await apiFetchAction(
    content.commit,
    'feedback/GetFeedbackById',
    'GET',
    TYPES.GET_FEEDBACK_DETAIL,
    payload,
    false,
    apiRoot
  );
};
// 获取反馈详情V2
const getFeedbackDetailByIdV2 = async (
  content: IActionContent,
  payload: object
) => {
  await apiFetchAction(
    content.commit,
    'feedback/GetFeedbackByIdV2',
    'GET',
    TYPES.GET_FEEDBACK_DETAIL_V2,
    payload,
    false,
    apiRoot
  );
};

// 获取客户列表
const getCustomerList = async (content: IActionContent, payload: object) => {
  apiFetchAction(
    content.commit,
    'feedback/getcustomer',
    'GET',
    TYPES.CUSTOMER_LIST,
    payload,
    false,
    apiRoot
  );
};

// 获取客户列表数据集
const getCustomerData = async (content: IActionContent, payload: object) => {
  return await apiFetchData(
    content.commit,
    'feedback/getcustomer',
    'GET',
    TYPES.CUSTOMER_LIST,
    payload,
    false,
    apiRoot
  );
};

// 获取用户列表
const getEmpliyeeList = async (content: IActionContent, payload: object) => {
  apiFetchAction(
    content.commit,
    'feedback/getdeveloperpm',
    'GET',
    TYPES.EMPLOYEE_LIST,
    payload,
    false,
    apiRoot
  );
};

// 获取用户列表数据集
const getEmpliyeeData = async (content: IActionContent, payload: object) => {
  return await apiFetchData(
    content.commit,
    'feedback/getdeveloperpm',
    'GET',
    TYPES.EMPLOYEE_LIST,
    payload,
    false,
    apiRoot
  );
};

// 获取PM用户列表
const getPMEmpliyeeList = async (content: IActionContent, payload: object) => {
  apiFetchAction(
    content.commit,
    'feedback/GetAllDeveloperPM',
    'GET',
    TYPES.PM_EMPLOYEE_LIST,
    payload,
    false,
    apiRoot
  );
};

// 获取PM用户列表数据集
const getPMEmpliyeeData = async (content: IActionContent, payload: object) => {
  return await apiFetchData(
    content.commit,
    'feedback/GetAllDeveloperPM',
    'GET',
    TYPES.PM_EMPLOYEE_LIST,
    payload,
    false,
    apiRoot
  );
};

// 获取SaaSPM用户列表
const getSaasEmpliyeeList = async (
  content: IActionContent,
  payload: object
) => {
  return await apiFetchData(
    content.commit,
    'feedback/getsaasdeveloperpm',
    'GET',
    TYPES.EMPLOYEE_LIST,
    payload,
    false,
    apiRoot
  );
};

// 获取项目名称列表
const getProjectList = async (content: IActionContent, payload: object) => {
  apiFetchAction(
    content.commit,
    'feedback/getproject',
    'GET',
    TYPES.PROJECT_LIST,
    payload,
    false,
    apiRoot
  );
};

// 获取项目名称数据集
const getProjectData = async (content: IActionContent, payload: object) => {
  return await apiFetchData(
    content.commit,
    'feedback/getproject',
    'GET',
    TYPES.PROJECT_LIST,
    payload,
    false,
    apiRoot
  );
};

// 获取所属子系统
const getProductSubsystemList = async (
  content: IActionContent,
  payload: object
) => {
  apiFetchAction(
    content.commit,
    'feedback/getsubsystem',
    'GET',
    TYPES.PORDUCT_SBUSYSTEM_LIST,
    payload,
    false,
    apiRoot
  );
};

// 获取模块
const getProductModuleList = async (
  content: IActionContent,
  payload: object
) => {
  apiFetchAction(
    content.commit,
    'feedback/getmodule',
    'GET',
    TYPES.PORDUCT_MODULE_LIST,
    payload,
    false,
    apiRoot
  );
};

// 获取产品版本
const getProductEditionList = async (
  content: IActionContent,
  payload: object
) => {
  apiFetchAction(
    content.commit,
    'feedback/getedition',
    'GET',
    TYPES.PORDUCT_EDITION_LIST,
    payload,
    false,
    apiRoot
  );
};


// 获取所有所属子系统
const getAllProductSubsystemList = async (
  content: IActionContent,
  payload: object
) => {
  apiFetchAction(
    content.commit,
    'feedback/getsubsystemall',
    'GET',
    TYPES.PORDUCT_SBUSYSTEM_ALL_LIST,
    payload,
    false,
    apiRoot
  );
};

// 获取所有模块
const getAllProductModuleList = async (
  content: IActionContent,
  payload: object
) => {
  apiFetchAction(
    content.commit,
    'feedback/getmoduleall',
    'GET',
    TYPES.PORDUCT_MODULE_ALL_LIST,
    payload,
    false,
    apiRoot
  );
};

// 获取所有产品版本
const getAllProductEditionList = async (
  content: IActionContent,
  payload: object
) => {
  apiFetchAction(
    content.commit,
    'feedback/geteditionall',
    'GET',
    TYPES.PORDUCT_EDITION_ALL_LIST,
    payload,
    false,
    apiRoot
  );
};

const addFeedback = async (content: IActionContent, payload: object) => {
  apiFetchAction(
    content.commit,
    'feedback/addfeedback',
    'POST',
    TYPES.COMMIT_PRODUCT_FEEDBACK,
    payload,
    false,
    apiRoot
  );
};
// 内部反馈提单
const addInsideFeedback = async (content: IActionContent, payload: object) => {
  apiFetchAction(
    content.commit,
    'feedback/addInsideFeedback',
    'POST',
    TYPES.COMMIT_PRODUCT_FEEDBACK,
    payload,
    false,
    apiRoot
  );
};

const updateFeedback = async (content: IActionContent, payload: object) => {
  apiFetchAction(
    content.commit,
    'feedback/updatefeedback',
    'POST',
    TYPES.UPDATE_PRODUCT_FEEDBACK,
    payload,
    false,
    apiRoot
  );
};

const updateFeedbackIsFirst = async (content: IActionContent, payload: object) => {
  apiFetchAction(
    content.commit,
    'feedback/UpdateFeedbackIsFirst',
    'POST',
    TYPES.UPDATE_FIRST_PRODUCT_FEEDBACK,
    payload,
    false,
    apiRoot
  );
};

// 转单
const transferFeedback = async (content: IActionContent, payload: object) => {
  apiFetchAction(
    content.commit,
    'feedback/TransferFeedback',
    'POST',
    TYPES.TRANSFER_FEEDBACK,
    payload,
    false,
    apiRoot
  );
};

// 外部新增反馈
const addFeedbackByExternal = async (content: IActionContent, payload: object) => {
  apiFetchAction(
    content.commit,
    'feedback/AddFeedbackByExternal',
    'POST',
    TYPES.SAVE_FEEDBACKBYEXTERNAL,
    payload,
    false,
    apiRoot
  );

};
const getFeedbackTotal = async (content: IActionContent, payload: object) => {
  apiFetchAction(
    content.commit,
    'Feedback/GetMySelfStatistic',
    'GET',
    TYPES.FEEDBACK_TOTAL,
    payload,
    false,
    apiRoot
  );
};

const getSubsystem = async (content: IActionContent, payload: object) => {
  apiFetchAction(
    content.commit,
    'Feedback/GetSubsystem?typeEnum=1',
    'GET',
    TYPES.GET_SUBSYSTEM,
    payload,
    false,
    apiRoot
  );
};

const getAssignee = async (content: IActionContent, payload: object) => {
  apiFetchAction(
    content.commit,
    'Feedback/GetAssignee',
    'GET',
    TYPES.GET_ASSIGNEE,
    payload,
    false,
    apiRoot
  );
};

const getDefaultAssignee = async (content: IActionContent, payload: object) => {
  apiFetchAction(
    content.commit,
    'Feedback/GetDefaultAssignee',
    'GET',
    TYPES.GET_DEFAULT_ASSIGNEE,
    payload,
    false,
    apiRoot
  );
};

const addDefaultAssignee = async (content: IActionContent, payload: any) => {
  apiFetchAction(
    content.commit,
    'Feedback/AddDefaultAssignee',
    'POST',
    TYPES.ADD_DEFAULT_ASSIGNEE,
    payload,
    false,
    apiRoot
  );
};

const getAssigneePermission = async (content: IActionContent, payload: any) => {
  apiFetchAction(
    content.commit,
    'Feedback/HasAssigneePermission',
    'GET',
    TYPES.GET_ASSIGNEE_PERMISSIONS,
    payload,
    false,
    apiRoot
  );
};

const RevokeFeedback = async (content: IActionContent, payload: any) => {
  apiFetchAction(
    content.commit,
    'Feedback/RevokeFeedback',
    'GET',
    TYPES.REVOKE_FEEDBACK,
    payload,
    false,
    apiRoot
  );
};

  // 满意度评价
  const FeedbackSatisfaction = async (content: IActionContent, payload: any) => {
    apiFetchAction(
      content.commit,
      'Feedback/FeedbackSatisfaction',
      'POST',
      TYPES.ADD_FeedbackSatisfaction,
      payload,
      false,
      apiRoot
    );
  };

  const getFeedbackSatisfactionList = async (content: IActionContent, payload: any) => {
    apiFetchAction(
      content.commit,
      'Feedback/GetFeedbackSatisfaction',
      'GET',
      TYPES.GET_FeedbackSatisfaction,
      payload,
      false,
      apiRoot
    );
  };

  // 判断是否存在转单信息
  const exsitTransfer = async (content: IActionContent, payload: any) => {
    apiFetchAction(
        content.commit,
        'Feedback/ExsitTransfer',
        'GET',
        TYPES.EXIST_FEEDBACKSTRANSFER,
        payload,
        false,
        apiRoot
    );
  };

    // 保存转单信息
    const saveFeedbackTransfer = async (content: IActionContent, payload: any) => {
      apiFetchAction(
          content.commit,
          'Feedback/SaveFeedbackTransfer',
          'POST',
          TYPES.SAVE_FEEDBACKSTRANSFER,
          payload,
          false,
          apiRoot
      );
    };
    // 查询转单信息
    const getFeedbackTransfer = async (content: IActionContent, payload: any) => {
      apiFetchAction(
          content.commit,
          'Feedback/GetFeedbackTransfer',
          'GET',
          TYPES.GET_FEEDBACKSTRANSFER,
          payload,
          false,
          apiRoot
      );
    };   
    
    // 接收转单
    const receiveTransfer = async (content: IActionContent, payload: any) => {
      apiFetchAction(
          content.commit,
          'Feedback/ReceiveTransfer',
          'POST',
          TYPES.RECEIVE_FEEDBACKSTRANSFER,
          payload,
          false,
          apiRoot
      );
    };  
    // 转单拒收
    const rejectionTransfer = async (content: IActionContent, payload: any) => {
      apiFetchAction(
          content.commit,
          'Feedback/RejectionTransfer',
          'POST',
          TYPES.REJECTION_FEEDBACKSTRANSFER,
          payload,
          false,
          apiRoot
      );
    }; 
    // 转单催接收
    const urgeTransfer = async (content: IActionContent, payload: any) => {
      apiFetchAction(
          content.commit,
          'Feedback/UrgeTransfer',
          'GET',
          TYPES.URGE_FEEDBACKSTRANSFER,
          payload,
          false,
          apiRoot
      );
    }; 
    // 转单撤单
    const cancelTransfer = async (content: IActionContent, payload: any) => {
      apiFetchAction(
          content.commit,
          'Feedback/CancelTransfer',
          'GET',
          TYPES.CANCEL_FEEDBACKSTRANSFER,
          payload,
          false,
          apiRoot
      );
    }; 
    // 判断是否是产品人员（天际、产品研发、产品运营）
    const getIsProductUser = async (content: IActionContent, payload: any) => {
      apiFetchAction(
          content.commit,
          'Feedback/IsProductUser',
          'GET',
          TYPES.IS_PRODUCTUSER,
          payload,
          false,
          apiRoot
      );
    };
    // 判断是否具有提交BUG权限（一线、天际、产品研发、产品运营）
    const getIsSubmitBugByUser = async (content: IActionContent, payload: any) => {
      apiFetchAction(
          content.commit,
          'Feedback/IsSubmitBugByUser',
          'GET',
          TYPES.IS_SUBMITBUGBYUSER,
          payload,
          false,
          apiRoot
      );
    };    

    // 获取模块默认经办人
    const getDefaultAssigneeByModule = async (content: IActionContent, payload: any) => {
      apiFetchAction(
          content.commit,
          'Feedback/GetDefaultAssigneeByModule',
          'GET',
          TYPES.GET_DEFAULTASSIGNEEBYMODULE,
          payload,
          false,
          apiRoot
      );
    };    
    const saveDefaultAssigneeByModule = async (content: IActionContent, payload: any) => {
      apiFetchAction(
          content.commit,
          'Feedback/SaveDefaultAssigneeByModule',
          'POST',
          TYPES.SAVE_DEFAULTASSIGNEEBYMODULE,
          payload,
          false,
          apiRoot
      );
    };
    
    // 获取产品数据
const getProductValueList = async (content: IActionContent, payload: object) => {
  apiFetchAction(
    content.commit,
    'Config/getSystemDisplayList',
    'GET',
    TYPES.System_Display_LIST,
    payload,
    false,
    apiRoot
  );
};
//保存产品顺序和是否启用
const SaveSystemConfigSet = async (content: IActionContent, payload: any) => {
  apiFetchAction(
      content.commit,
      'Config/SaveSystemConfigSet',
      'POST',
      TYPES.SAVE_DEFAULTASSIGNEEBYMODULE,
      payload,
      false,
      apiRoot
  );
};

export const actions = {
  getFeedbackList,
  getFeedbackDetailById,
  getFeedbackDetailByIdV2,
  addFeedbackByExternal,
  getCustomerList,
  getCustomerData,
  getEmpliyeeList,
  getSaasEmpliyeeList,
  getEmpliyeeData,
  getPMEmpliyeeList,
  getPMEmpliyeeData,
  getProjectList,
  getProjectData,
  getProductSubsystemList,
  getProductModuleList,
  getProductEditionList,

  getAllProductSubsystemList,
  getAllProductModuleList,
  getAllProductEditionList,

  addInsideFeedback,
  addFeedback,
  updateFeedback,
  updateFeedbackIsFirst,
  transferFeedback,
  getFeedbackTotal,
  getSubsystem,
  getAssignee,
  getDefaultAssignee,
  addDefaultAssignee,
  getAssigneePermission,
  RevokeFeedback,
  FeedbackSatisfaction,
  getFeedbackSatisfactionList,

  exsitTransfer,
  saveFeedbackTransfer,
  getFeedbackTransfer,
  
  receiveTransfer,
  rejectionTransfer,
  urgeTransfer,
  cancelTransfer,
  getIsProductUser,
  getIsSubmitBugByUser,

  getDefaultAssigneeByModule,
  saveDefaultAssigneeByModule,
  getProductValueList,
  SaveSystemConfigSet
};
